"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _core = require("@material-ui/core");
var _react = _interopRequireWildcard(require("react"));
var _reactPerfectScrollbar = _interopRequireDefault(require("react-perfect-scrollbar"));
require("react-perfect-scrollbar/dist/css/styles.css");
var _Translations = require("react-platform-components/dist/Translations");
var _reactRedux = require("react-redux");
var _reactRouterDom = require("react-router-dom");
var _Utils = require("./Utils");
var _ChatActions = require("../Chat/ChatActions");
var _ContactListItem = _interopRequireDefault(require("./ContactListItem"));
var _classnames = _interopRequireDefault(require("classnames"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"]; if (null != _i) { var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1; try { if (_x = (_i = _i.call(arr)).next, 0 === i) { if (Object(_i) !== _i) return; _n = !1; } else for (; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0) { ; } } catch (err) { _d = !0, _e = err; } finally { try { if (!_n && null != _i.return && (_r = _i.return(), Object(_r) !== _r)) return; } finally { if (_d) throw _e; } } return _arr; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
var useStyles = (0, _core.makeStyles)(function (theme) {
  return {
    root: {
      display: 'flex',
      flex: '1 1 auto',
      flexDirection: 'column',
      height: '100%'
    },
    aboveSearchText: {
      height: "70px",
      display: "flex",
      justifyContent: "center",
      alignContent: "center",
      alignItems: "center",
      fontWeight: "bold",
      backgroundColor: theme.palette.third.third
    },
    typo: {
      color: theme.palette.third.contrastText
    },
    contentToolbar: {
      backgroundColor: theme.palette.third.third
    },
    Paper: {
      padding: "10px",
      backgroundColor: "#f5f5f5",
      borderRadius: "8px"
    },
    InputsBackround: {
      backgroundColor: "#f5f5f5",
      color: "black"
    },
    iconColor: {
      color: theme.palette.third.third
    }
  };
});
function ChatsSidebar(props) {
  var intl = props.intl;
  var classes = useStyles();
  var dispatch = (0, _reactRedux.useDispatch)();
  var _useState = (0, _react.useState)(''),
    _useState2 = _slicedToArray(_useState, 2),
    searchText = _useState2[0],
    handleSearchText = _useState2[1];
  var _useSelector = (0, _reactRedux.useSelector)(function (_ref) {
      var chatReducer = _ref.chatReducer;
      return {
        contacts: chatReducer.contacts,
        selectedContactId: chatReducer.selectedContactId
      };
    }),
    contacts = _useSelector.contacts,
    selectedContactId = _useSelector.selectedContactId;
  var contactsToShow = contacts.filter(function (contact) {
    return contact.number_of_messages > 0;
  });
  var handleContactClick = function handleContactClick(contactId) {
    props.history.push({
      pathname: "/chat/".concat(contactId)
    });
  };
  var closeChatPanel = function closeChatPanel() {
    dispatch({
      type: _ChatActions.CLOSE_CHAT_PANEL
    });
  };
  var getFilteredArray = function getFilteredArray(arr, searchText) {
    if (searchText.length === 0) {
      return arr;
    }
    return (0, _Utils.filterArrayByString)(arr, searchText);
  };
  var setSearchText = function setSearchText(event) {
    handleSearchText(event.target.value);
  };
  var closeMobileChatsSidebar = function closeMobileChatsSidebar() {
    dispatch({
      type: _ChatActions.CLOSE_MOBILE_CHATS_SIDEBAR
    });
  };
  var contactsArr = getFilteredArray(_toConsumableArray(contactsToShow), searchText);
  return /*#__PURE__*/_react.default.createElement("div", {
    className: classes.root
  }, /*#__PURE__*/_react.default.createElement(_core.AppBar, {
    className: classes.contentToolbar,
    position: "static",
    color: "default",
    elevation: 1
  }, /*#__PURE__*/_react.default.createElement(_core.Hidden, {
    mdUp: true
  }, /*#__PURE__*/_react.default.createElement(_core.Toolbar, {
    className: "flex justify-end items-center px-16 pr-4"
  }, /*#__PURE__*/_react.default.createElement(_core.IconButton, {
    "aria-owns": 'chats-more-menu',
    onClick: closeMobileChatsSidebar
  }, /*#__PURE__*/_react.default.createElement(_core.Icon, null, "close")))), /*#__PURE__*/_react.default.createElement("div", {
    className: classes.aboveSearchText
  }, /*#__PURE__*/_react.default.createElement(_core.Typography, {
    variant: "h3",
    align: "center",
    className: classes.typo
  }, /*#__PURE__*/_react.default.createElement(_Translations.IntlMessages, {
    id: "Discussions",
    defaultMessage: "Discussions"
  }))), /*#__PURE__*/_react.default.createElement(_core.Toolbar, {
    className: "px-16 my-2"
  }, /*#__PURE__*/_react.default.createElement(_core.Paper, {
    className: (0, _classnames.default)("flex p-4 items-center w-full rounded-8", "".concat(classes.Paper)),
    elevation: 1
  }, /*#__PURE__*/_react.default.createElement(_core.Icon, {
    className: (0, _classnames.default)("mr-2", "".concat(classes.iconColor)),
    color: "action"
  }, "search"), /*#__PURE__*/_react.default.createElement(_core.Input, {
    placeholder: intl.formatMessage({
      id: "Recherche...",
      defaultMessage: "Recherche..."
    }),
    className: (0, _classnames.default)("flex flex-1", "".concat(classes.InputsBackround)),
    disableUnderline: true,
    fullWidth: true,
    value: searchText,
    inputProps: {
      'aria-label': 'Search'
    },
    onChange: setSearchText
  })))), /*#__PURE__*/_react.default.createElement(_reactPerfectScrollbar.default, {
    className: "flex-1"
  }, /*#__PURE__*/_react.default.createElement(_core.List, {
    className: "w-full"
  }, contactsToShow.length > 0 && /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, contactsArr.map(function (contact) {
    return /*#__PURE__*/_react.default.createElement(_ContactListItem.default, {
      key: contact.id,
      contact: contact,
      selectedContactId: selectedContactId,
      onContactClick: handleContactClick
    });
  })))));
}
var _default = (0, _reactRouterDom.withRouter)((0, _Translations.injectIntl)(ChatsSidebar));
exports.default = _default;